'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Save and continue button
 */
var FinishTaskButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(FinishTaskButton, _Component);

  function FinishTaskButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FinishTaskButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FinishTaskButton.__proto__ || (0, _getPrototypeOf2.default)(FinishTaskButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      save: false
    }, _this.handleOnClick = function () {
      _this.state.save = true;
      _this.props.onChange();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  (0, _createClass3.default)(FinishTaskButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./FinishTaskButton.scss');
      return _react2.default.createElement(
        'div',
        null,
        !this.state.save && _react2.default.createElement(
          ReactBootstrap.ButtonToolbar,
          null,
          _react2.default.createElement(
            ReactBootstrap.Button,
            { bsStyle: 'success', onClick: this.handleOnClick },
            _react2.default.createElement('i', { className: 'fa fa-check' }),
            '  Save and continue'
          )
        ),
        this.state.save && _react2.default.createElement(
          ReactBootstrap.ButtonToolbar,
          null,
          _react2.default.createElement(
            ReactBootstrap.Button,
            { bsStyle: 'success', onClick: this.handleOnClick },
            _react2.default.createElement('i', { className: 'fa fa-check' }),
            '  Saved!'
          )
        ),
        _react2.default.createElement('div', { className: styles.spacer40 })
      );
    }
  }]);
  return FinishTaskButton;
}(_react.Component), _class.propTypes = {
  onChange: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = FinishTaskButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FinishTaskButton/FinishTaskButton.js
// module id = 1150
// module chunks = 0